import { useState } from 'react';
import ButtonBasic from '../../atoms/buttonBasic/view';
import { getPayMethods } from '../../../usecases/payments-usecase';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { formatMoney } from '../../../utils/formating';
import { lang } from '../../../utils/langs';
import ModalBtn from '../../molecules/modalButton/view';

const AccountPaymentModal = ({ id, onClose, account, type, onPaymentSuccess, hidden = false }) => {
    const [amount, setAmount] = useState(0);
    const [paymethodId, setPaymethodId] = useState('');
    const [paymethods, setPaymethods] = useState([]);
    const [reference, setReference] = useState('');
    const [loading, setLoading] = useState(false);

    const handleOpen = () => {
        if (account) {
            setAmount(account.current_balance || 0);
            setPaymethodId('');
            setReference('');
            fetchMethods();
        }
    }

    const fetchMethods = async () => {
        try {
            const methods = await getPayMethods("", "");
            setPaymethods(methods);
            if (methods.length > 0) setPaymethodId(methods[0].id);
        } catch (error) {
            console.error(error);
        }
    };

    const handleSubmit = async () => {
        if (!paymethodId) {
            dispatchCustomEvent('popup', { message: 'Selecciona un método de pago', type: 'error' });
            return;
        }

        if (amount <= 0 || amount > account.current_balance) {
            dispatchCustomEvent('popup', { message: 'Monto inválido o excede el saldo', type: 'error' });
            return;
        }

        setLoading(true);
        try {
            const { registerReceivablePayment, registerPayablePayment } = await import('../../../usecases/accounts-management-usecase');
            const { getCookie } = await import('../../../utils/cookies');
            const uid = getCookie('uid');
            const cid = getCookie('cid');

            const payload = {
                amount: parseFloat(amount),
                paymethod_id: parseInt(paymethodId),
                reference: reference
            };

            if (type === 'receivable') {
                await registerReceivablePayment(uid, cid, account.account_id, payload);
            } else {
                await registerPayablePayment(uid, cid, account.account_id, payload);
            }

            dispatchCustomEvent('popup', { message: 'Pago registrado con éxito', type: 'success' });
            dispatchCustomEvent('modal-close-account-payment');
            onPaymentSuccess();
            onClose();
        } catch (error) {
            dispatchCustomEvent('popup', { message: 'Error al registrar el pago', type: 'error' });
        } finally {
            setLoading(false);
        }
    };

    if (!account) return null;

    const labelStyle = { fontSize: '14px', color: '#666', marginBottom: '5px', display: 'block' };
    const inputStyle = { width: '100%', padding: '10px', borderRadius: '4px', border: '1px solid #ddd' };

    return (
        <ModalBtn
            id={"payment-" + id}
            title="Abonar"
            onClick={handleOpen}
            hidden={hidden}
        >
            <div style={{ padding: '20px' }}>
                <h3 style={{ marginBottom: '20px' }}>Registrar Pago</h3>
                <div style={{ background: '#f8f9fa', padding: '15px', borderRadius: '8px', marginBottom: '20px' }}>
                    <p style={{ margin: '5px 0' }}>Documento: <strong>{account.number}</strong></p>
                    <p style={{ margin: '5px 0' }}>Saldo Pendiente: <strong style={{ color: '#d32f2f' }}>{formatMoney(account.current_balance)}</strong></p>
                </div>

                <div className="form-group" style={{ marginBottom: '15px' }}>
                    <label style={labelStyle}>Monto a Pagar</label>
                    <input
                        type="number"
                        className="form-control"
                        value={amount}
                        onChange={(e) => setAmount(e.target.value)}
                        style={inputStyle}
                    />
                </div>

                <div className="form-group" style={{ marginBottom: '15px' }}>
                    <label style={labelStyle}>Método de Pago</label>
                    <select
                        className="form-control"
                        value={paymethodId}
                        onChange={(e) => setPaymethodId(e.target.value)}
                        style={inputStyle}
                    >
                        <option value="">Selecciona un método...</option>
                        {paymethods.map(m => (
                            <option key={m.id} value={m.id}>{lang('es', m.method)}</option>
                        ))}
                    </select>
                </div>

                <div className="form-group" style={{ marginBottom: '15px' }}>
                    <label style={labelStyle}>Referencia / Observaciones</label>
                    <input
                        type="text"
                        className="form-control"
                        value={reference}
                        onChange={(e) => setReference(e.target.value)}
                        style={inputStyle}
                    />
                </div>

                <div style={{ display: 'flex', gap: '10px', marginTop: '20px', justifyContent: 'flex-end' }}>
                    <ButtonBasic onClick={() => {
                        dispatchCustomEvent('modal-close-account-payment');
                        onClose();
                    }} color="secondary">Cancelar</ButtonBasic>
                    <ButtonBasic onClick={handleSubmit} showLoading={loading}>Confirmar Pago</ButtonBasic>
                </div>
            </div>
        </ModalBtn>
    );
};

export default AccountPaymentModal;

